var _style, _circle, _path, _rect, _g, _rect2, _rect3, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 250",
    style: {
      enableBackground: "new 0 0 250 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#E52828;}\n\t.st2{fill:none;stroke:#FF1F1F;stroke-width:2;stroke-miterlimit:10;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 124.4,
    cy: 123.6,
    r: 101.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M230.6,107.9l4.5-10.3l-8.8-7l2.7-10.8l-9.8-5.4l0.9-11.1l-10.6-3.8l-1-11.1l-11-1.9l-2.8-10.8l-11.2-0.1 l-4.3-10.2l-11,1.7l-6.2-9.3l-10.7,3.6l-7.6-8.2l-9.9,5.2l-8.9-6.8l-8.3,6.4l-9.2-5L99.6,21l-10.5-3.7l-6.3,9.3l-11-1.8l-4.6,10.2 H56l-2.9,10.8l-10.9,1.7L41,58.7l-10.6,3.6l0.8,11.1l-9.9,5.3L24,89.6l-8.8,6.9l4.4,10.3l-7.6,8.2l6,9.5l-6.1,9.4l7.5,8.3l-4.5,10.3 l8.8,7L21,170.2l9.8,5.4l-0.9,11.1l10.6,3.7l1,11.1l11,1.9l2.8,10.8l11.2,0.1l4.3,10.3l11-1.7l6.2,9.3l10.7-3.6l7.6,8.2l9.9-5.2 l8.9,6.8l8.3-6.4l9.2,5l7.7-8.1l10.6,3.7l6.3-9.3l11,1.8l4.6-10.2h11.2l2.9-10.8l11-1.8l1.1-11.1l10.6-3.6l-0.8-11.1l9.9-5.3 l-2.6-10.8l8.8-6.9l-4.4-10.3l7.6-8.2l-6-9.4l6.1-9.4L230.6,107.9z M99.6,75.2h32.9v7.6h-24v9.9h22.3v7.5h-22.3v12.1h24.8v7.5H99.6 V75.2z M79.3,119.7l-17.9-29v29h-8.3V75.2h8.7L80,104.9V75.2h8.3v44.4H79.3z M161.7,167.3l-14.9,10.8c-1.7,1.3-2.5,3.6-1.8,5.7 l5.7,17.5c1.5,4.7-3.9,8.6-7.8,5.7l-14.9-10.8c-1.7-1.3-4.3-1.3-6,0L107,207.1c-4,2.9-9.4-1-7.8-5.7l5.7-17.5 c0.7-2.1-0.1-4.5-1.8-5.7l-14.9-10.8c-4-2.9-1.9-9.2,3-9.2h18.4c2.2,0,4.2-1.5,4.8-3.5l5.7-17.5c1.5-4.7,8.2-4.7,9.7,0l5.7,17.5 c0.7,2.1,2.6,3.5,4.8,3.5h18.4C163.6,158.1,165.7,164.4,161.7,167.3z M186.2,119.7h-9.5l-8.8-33.2l-8.8,33.2h-9.7l-10.7-44.4h9.2 l6.7,30.5l8.1-30.5h10.7l7.7,31l6.8-31h9L186.2,119.7z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.1,
    y: 61.2,
    className: "st1",
    width: 143.9,
    height: 146.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.4,169.3l-14.2-50.9l11.7-3.3l29.8,33.8l-0.6,1.1l-11.1-40l9.2-2.6l14.2,50.9l-11.8,3.3l-29.6-33.2l0.6-1.1 l10.9,39.4L60.4,169.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.7,155.4l-14.2-51l9.6-2.7l14.2,51L110.7,155.4z M102.6,112.7l-2.6-9.3l30.7-8.5l2.6,9.3L102.6,112.7z  M108.4,133.7l-2.6-9.3l26.8-7.5l2.6,9.3L108.4,133.7z M114.2,154.4l-2.6-9.3l30.7-8.5l2.6,9.3L114.2,154.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.1,123.4l0.3-36.7l7.7-2.1l19.2,31.3L184.4,80l9.9-2.7l2.4,54.2l-9,2.5l-18.9-33.1l0.4,38.2l-9,2.5 l-25.9-47.7l9.9-2.7L160.1,123.4z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.7,
    y: 83.4,
    transform: "matrix(0.9635 -0.2678 0.2678 0.9635 -18.523 33.2713)",
    className: "st0",
    width: 172,
    height: 2.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 51.3,
    y: 164.3,
    transform: "matrix(0.9635 -0.2678 0.2678 0.9635 -39.2991 42.8162)",
    className: "st0",
    width: 172,
    height: 2.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 125,
    cy: 125,
    r: 119.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIcon);
export default __webpack_public_path__ + "static/media/new_icon.c1da2423c9d5cbbe66387c42768234e2.svg";
export { ForwardRef as ReactComponent };